import { render, staticRenderFns } from "./LoginVerifyOtpPanel.vue?vue&type=template&id=64a89958&"
import script from "./LoginVerifyOtpPanel.vue?vue&type=script&lang=js&"
export * from "./LoginVerifyOtpPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports